import { FadeContainer } from '~/components/ui/FadeContainer';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import adsHeadLogo from '../../assets/images/ads_head_logo.svg';
import { AdsStages } from '../../models/Ads';
import { setActiveAdsState, useLayoutDispatch } from '../../redux';
import { AppAdsItem } from '../AppAdsItem';
import {
	StyledContainer,
	StyledCreateButton,
	StyledEmptyList,
	StyledHead,
	StyledList,
	StyledScrollContainerWrapper,
} from './AppAdsMyAds.styled';

const AppAdsMyAds = () => {
	const dispatch = useLayoutDispatch();
	const myAds = useObservable(rage.ads.getMyAds());

	return (
		<StyledContainer>
			<StyledHead>
				<img src={adsHeadLogo} />
				<Text
					style={{
						fontSize: 18,
						fontWeight: 500,
						color: '#ffffff',
						textAlign: 'center',
					}}
				>
					Мои объявления
				</Text>
				<StyledCreateButton
					onClick={() => dispatch(setActiveAdsState(AdsStages.CREATE))}
				/>
			</StyledHead>
			<StyledScrollContainerWrapper>
				<FadeContainer height={435}>
					<StyledList>
						{myAds.length === 0 ? (
							<StyledEmptyList>
								<Text
									style={{
										fontSize: 14,
										color: 'rgba(255, 255, 255, 0.35)',
										textAlign: 'center',
										padding: '24px 16px',
									}}
								>
									У вас пока нет объявлений
								</Text>
							</StyledEmptyList>
						) : (
							myAds.map((item) => (
								<AppAdsItem key={item.id} item={item} isMyAds />
							))
						)}
					</StyledList>
				</FadeContainer>
			</StyledScrollContainerWrapper>
		</StyledContainer>
	);
};

export { AppAdsMyAds };
